// extracted by mini-css-extract-plugin
export default {"timerDisplay":"TimerDisplay_timerDisplay__HwoqH","pauseIcon":"TimerDisplay_pauseIcon__D-qKK"};